<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <button-export
        :href="exportUrl"
        download="download.xls"
        :beforeDownload="beforeDownload"
        v-if="permissionCodes.indexOf('008003001') !== -1"
        value="导出"/>
      <input-select :selectTitle="'缴费状态'" style="margin-right: 10px;" :selectData="payStatusList" @search="search" :selectKey="'payStatus'" />
      <!--<div style="display: flex;justify-content: space-between">-->
        <!--<input-select selectTitle="缴费方式" :selectKey="'payWay'" :selectData="payWayList" @search="search"/>-->
      <!--</div>-->
      <input-search placeholder="缴费人姓名/手机号" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :hasOperation="false" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/SiteReservation'
  import {bus} from '../../../utils/bus'
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    components: {
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb},
    name: 'pay-record',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧预约',
          name: 'pay-record'
        }, {
          value: '缴费记录'
        }],
        exportUrl: '',
        payStatusList: [{
          key: '',
          label: '全部'
        }, {
          key: '0',
          label: '未缴费'
        }, {
          key: '1',
          label: '已缴费'
        }],
        tableHead: [{
          prop: 'personName',
          label: '缴费人姓名'
        }, {
          prop: 'personPhone',
          label: '缴费人手机'
        }, {
          prop: 'enterpriseName',
          label: '缴费人所属住户'
        },{
          prop: 'payAmount',
          label: '金额(元)'
        }, {
          prop: 'placeName',
          label: '场地名称'
        }, {
          prop: 'consumeTime',
          label: '缴费时间'
        }],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        selectionArr: [],
        requestData: {
          searchKey: '',
          payStatus: ''
        }
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getPage()
    },
    methods: {
      beforeDownload () {
        this.exportUrl = `${api.exportPlaceBooking}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&payStatus=${this.requestData.payStatus}`
      },
      getPage () {
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        this.$axios.post(api.getPlaceBookingPage, reqData)
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取缴费信息失败'))
      },
      search (v) {
        this.pageNum = 1
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .el-input--small .el-input__inner {
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/view/SiteReservation/PaymentRecord/SitePayRecord.vue